// extracted by mini-css-extract-plugin
export default {"container":"WidgetGraphicPreview_container__0s3Hn","chart":"WidgetGraphicPreview_chart__kHr+J"};